import Repository from "../../repository";

export default {
    GetImageToSync: (payload) => Repository.post(`/api/WimImages/GetImageToSync`, payload),
    UpdateImageIsSync: (payload) => Repository.post(`/api/WimImages/UpdateImageIsSync`, payload),
    LogFilesSync: (payload) => Repository.post(`/api/WimImages/LogFilesSync`, payload),
}
